export const isModalOpened = (state) => state.modal.isModalOpened;
export const getModalProps = (state) => state.modal.modalProps;
